module.exports = __webpack_public_path__ + "img/ConstructionOutlined.41ce12e2.svg";